import React from "react";
import { Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  QboFieldType,
  TemplateFieldV2,
} from "../../../../docuclipper/DocuclipperTypes";
import { ReduxState } from "../../../../redux";
import { updateQboConfig } from "../../../../redux/reducers/TemplateField";
import AdvancedOptions from "./QboOptions/AdvancedOptions";
import { withSelectedField } from "./withSelectedField";

type Props = {
  qboConfig: TemplateFieldV2["qbo"];
  tableConfig: TemplateFieldV2["tableConfig"];
  onQboConfigChange: (qboConfig: TemplateFieldV2["qbo"]) => any;
};

export const QboConfig2: React.SFC<Props> = ({
  qboConfig,
  tableConfig,
  onQboConfigChange,
}) => {
  const fields = [
    "name",
    "date",
    "credit",
    "debit",
    "amount",
    "balance",
    "date2",
    "checkNumber",
  ];
  const { token } = useSelector((state: ReduxState) => state.Auth);
  const isAdmin =
    token && token.permissions && token.permissions.includes("READ_DB_TABLES");
  return (
    <>
      <Form.Check
        onChange={(e) =>
          onQboConfigChange(
            e.target.checked
              ? {
                  columnMapping: {
                    amount: null,
                    balance: null,
                    credit: null,
                    debit: null,
                    name: null,
                    date: null,
                    date2: null,
                    checkNumber: null,
                  },
                  fieldType: "both",
                }
              : undefined
          )
        }
        type="checkbox"
        label="Enable QuickBooks"
        checked={!!qboConfig}
      />
      {qboConfig && tableConfig && (
        <>
          <Form.Group controlId="qboFieldType" className="my-2">
            <Form.Label>
              <strong>Field Type</strong>
            </Form.Label>
            <Form.Control
              as="select"
              onChange={(e) =>
                onQboConfigChange({
                  ...qboConfig,
                  fieldType: e.target.value as QboFieldType,
                })
              }
            >
              {["debits", "credits", "both"].map((option) => (
                <option
                  selected={qboConfig.fieldType === option}
                  value={option}
                >
                  {option}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <div className="ml-3">
            <Row>
              <Form.Check
                type="checkbox"
                checked={qboConfig.creditsAreNegative}
                onChange={(e) =>
                  onQboConfigChange({
                    ...qboConfig,
                    creditsAreNegative: e.target.checked,
                  })
                }
              />
              Credits are negative
            </Row>
          </div>

          <div className="my-2">
            {isAdmin && (
              <Form.Control
                as="select"
                onChange={(e) => {
                  const val = e.target.value;
                  if (val) {
                    const tokens = val.split("-");

                    onQboConfigChange({
                      ...qboConfig,
                      columnMapping: {
                        amount:
                          tokens.indexOf("A") === -1
                            ? null
                            : tokens.indexOf("A"),
                        credit:
                          tokens.indexOf("Cr") === -1
                            ? null
                            : tokens.indexOf("Cr"),
                        date:
                          tokens.indexOf("D") === -1
                            ? null
                            : tokens.indexOf("D"),
                        debit:
                          tokens.indexOf("De") === -1
                            ? null
                            : tokens.indexOf("De"),
                        name:
                          tokens.indexOf("N") === -1
                            ? null
                            : tokens.indexOf("N"),
                        date2:
                          tokens.indexOf("D2") === -1
                            ? null
                            : tokens.indexOf("D2"),
                        balance:
                          tokens.indexOf("B") === -1
                            ? null
                            : tokens.indexOf("B"),
                      },
                    });
                  }
                }}
              >
                {[
                  "",
                  "D-N-Cr-De-B",
                  "D-N-De-Cr-B",
                  "D-N-A",
                  "D-A-N",
                  "N-D-A",
                  "D-D2-N-A",
                ].map((option) => (
                  <option value={option}>{option}</option>
                ))}
              </Form.Control>
            )}

            {fields.map((field) => {
              return (
                <Form.Group controlId="qbo">
                  <Form.Label>
                    <strong>{field}</strong>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    onChange={(e) =>
                      onQboConfigChange({
                        ...qboConfig,
                        columnMapping: {
                          ...qboConfig.columnMapping,
                          [field]: e.target.value
                            ? Number(e.target.value)
                            : null,
                        },
                      })
                    }
                  >
                    <>
                      <option
                        selected={qboConfig.columnMapping[field] === null}
                      >
                        null
                      </option>
                      {tableConfig.columns.map((col, i) => (
                        <option
                          selected={qboConfig.columnMapping[field] === i}
                          value={i}
                        >
                          {i}
                        </option>
                      ))}
                    </>
                  </Form.Control>
                </Form.Group>
              );
            })}
            <div className="mt-2">
              <AdvancedOptions />
            </div>
          </div>
        </>
      )}
    </>
  );
};

const QboConfig_: React.FC<{ field: TemplateFieldV2 }> = ({ field }) => {
  const dispatch = useDispatch();
  return (
    <QboConfig2
      qboConfig={field.qbo}
      tableConfig={field.tableConfig}
      onQboConfigChange={(qboConfig) => {
        dispatch(
          updateQboConfig({
            id: field.id,
            qboConfig,
          })
        );
      }}
    />
  );
};

export const QboConfig = withSelectedField(QboConfig_);
